'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULTS = {
    transitionName: 'fade',
    duration: 300,
    appear: false
};

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS,
        transitionName = _ref.transitionName,
        duration = _ref.duration,
        appear = _ref.appear;

    return function (DecoratedComponent) {
        var AnimateFadeDecorator = function AnimateFadeDecorator(_ref2) {
            var _ref2$fadeIn = _ref2.fadeIn,
                fadeIn = _ref2$fadeIn === undefined ? false : _ref2$fadeIn,
                _ref2$show = _ref2.show,
                show = _ref2$show === undefined ? true : _ref2$show,
                props = _objectWithoutProperties(_ref2, ['fadeIn', 'show']);

            if (fadeIn) {
                return _react2.default.createElement(
                    _CSSTransitionGroup2.default,
                    {
                        transitionName: transitionName,
                        transitionAppear: appear,
                        transitionAppearTimeout: duration,
                        transitionEnterTimeout: duration,
                        transitionLeaveTimeout: duration },
                    show ? _react2.default.createElement(DecoratedComponent, props) : null
                );
            }

            return show ? _react2.default.createElement(DecoratedComponent, props) : null;
        };

        AnimateFadeDecorator.propTypes = {
            fadeIn: _propTypes2.default.bool,
            show: _propTypes2.default.bool
        };

        return AnimateFadeDecorator;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/animations/animateFadeDecorator.js
// module id = 675
// module chunks = 0